import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

// fetch
import { getProfileV2 } from "data/fetch";

export function useProfileQuery(uei, cage_code) {
  const [errorType, setErrorType] = useState<
    "NOT_FOUND" | "SERVER_ERROR" | null
  >(null);

  const { isPending, data, error, dataUpdatedAt } = useQuery({
    queryKey: ["profile", uei, cage_code],

    queryFn: () => getProfileV2(uei, cage_code),

    gcTime: 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    enabled: Boolean(uei && cage_code),
    retry: false,
    throwOnError: false,
  });

  useEffect(() => {
    if (error) {
      const status =
        (error as any)?.response?.status || (error as any)?.status || 500;
      switch (status) {
        case 404:
          setErrorType("NOT_FOUND");
          break;
        case 500:
          setErrorType("SERVER_ERROR");
          break;
        default:
          setErrorType(null);
          break;
      }
    } else {
      setErrorType(null); // Clear error state when no error
    }
  }, [error]);

  return {
    data,
    isPending,
    errorType,
    dataUpdatedAt,
  };
}